export const config = {
  firebase: {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
  },
  baseUrl: process.env.REACT_APP_BASE_URL,
  algolia: {
    searchKey: process.env.REACT_APP_ALGOLIA_SEARCH_KEY,
    appId: process.env.REACT_APP_ALGOLIA_APP_ID,
  },
  emailUrl: process.env.REACT_APP_EMAIL_URL,
};
